import { render, staticRenderFns } from "./SellCoinsEmptyState.vue?vue&type=template&id=59e7f716&scoped=true&"
import script from "./SellCoinsEmptyState.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsEmptyState.vue?vue&type=style&index=0&id=59e7f716&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e7f716",
  null
  
)

export default component.exports